import { IProps } from "../types";
import { RadioButtonListItem } from "components/RadioButtonList";

export interface ISelectProvidersProps extends IProps {
    onClose: any;
    posX?: number;
    posY?: number;
    widget?: string;
    handleTotalSelected?: any;
}

export interface ProviderInfo
{
    name: string;
    selected: boolean;
    averageStartRating: number;
}

export const providerSelectorTexts: any = {
    'overall': { title: 'Roll up ratings from', subtitle: 'Source' },
    'providersRating': {title: 'Providers reviews (minimum 3) : ' , subtitle: 'Providers and # of reviews'},
    'leaveReview': {title: 'Select Providers to Display:', subtitle: 'Source' },
    'reviewList': {title: 'Select sources to Display:', subtitle: 'Source' },
    'entire': {title: 'Select Providers to display.  A minimum of 3 is recommended. ', subtitle: 'Providers and # of reviews ' },
};

export const radioButtonListItems: RadioButtonListItem[] = [
    {
    id: `0`,
    name: 'Select All',
    enable: true,
    itemMessage:""
    }, {
        id: `1`,
        name: 'Clear All',
        enable: true,
        itemMessage:""
    }
];